import { render, staticRenderFns } from "./list_branches.vue?vue&type=template&id=29adc35d&scoped=true"
import script from "./list_branches.vue?vue&type=script&lang=js"
export * from "./list_branches.vue?vue&type=script&lang=js"
import style0 from "./list_branches.vue?vue&type=style&index=0&id=29adc35d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29adc35d",
  null
  
)

/* custom blocks */
import block0 from "./list_branches.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports